export function calculatePowerPerYear(kwPerDay, lifetime) {
    return Math.round(kwPerDay * 365 * lifetime);
}
